import React, { createContext, useContext, useState, useEffect } from 'react';

const BasketContext = createContext(null);

export const BasketProvider = ({ children }) => {
  const [basket, setBasket] = useState(() => {
    try {
      const saved = localStorage.getItem('shop_basket');
      return saved ? JSON.parse(saved) : [];
    } catch { return []; }
  });

  // Persist basket to localStorage
  useEffect(() => {
    localStorage.setItem('shop_basket', JSON.stringify(basket));
  }, [basket]);

  const addToBasket = (product) => {
    setBasket(prev => {
      const pid = product.product_id || product.book_id;
      const existing = prev.find(i => i.product_id === pid);
      if (existing) {
        return prev.map(i => i.product_id === pid ? { ...i, quantity: i.quantity + 1 } : i);
      }
      return [...prev, {
        product_id: pid,
        type: product.type || 'book',
        title: product.title,
        price: product.price || product.physical_price || 0,
        image_url: product.image_url,
        quantity: 1
      }];
    });
  };

  const updateQuantity = (productId, delta) => {
    setBasket(prev => prev.map(i => {
      if (i.product_id === productId) {
        const newQty = Math.max(0, i.quantity + delta);
        return newQty === 0 ? null : { ...i, quantity: newQty };
      }
      return i;
    }).filter(Boolean));
  };

  const removeFromBasket = (productId) => {
    setBasket(prev => prev.filter(i => i.product_id !== productId));
  };

  const clearBasket = () => setBasket([]);

  const basketCount = basket.reduce((sum, i) => sum + i.quantity, 0);
  const basketSubtotal = basket.reduce((sum, i) => sum + (i.price * i.quantity), 0);

  return (
    <BasketContext.Provider value={{ basket, addToBasket, updateQuantity, removeFromBasket, clearBasket, basketCount, basketSubtotal }}>
      {children}
    </BasketContext.Provider>
  );
};

export const useBasket = () => {
  const context = useContext(BasketContext);
  if (!context) return { basket: [], addToBasket: () => {}, updateQuantity: () => {}, removeFromBasket: () => {}, clearBasket: () => {}, basketCount: 0, basketSubtotal: 0 };
  return context;
};
